import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, map, Observable, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'lgv-rates-today-and-historical-combo',
    templateUrl: './rates-today-and-historical-combo.component.html',
    styleUrls: ['./rates-today-and-historical-combo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatesTodayAndHistoricalComboComponent implements OnInit, OnDestroy {

    pageMode$ = new BehaviorSubject('TodaysRates');
    get isTodaysRatesMode$(): Observable<boolean> { return this.pageMode$.pipe(takeUntil(this.onDestroy$), map(x => x === 'TodaysRates')) }
    get isHistoricalRatesMode$(): Observable<boolean> { return this.pageMode$.pipe(takeUntil(this.onDestroy$), map(x => x === 'HistoricalRates')) }

    onDestroy$ = new Subject();

    constructor() { }

    ngOnInit(): void {
    }
    ngOnDestroy(): void {
        this.onDestroy$.complete();
    }

    setPageMode(mode: string) {
        this.pageMode$.next(mode);
    }

}
